import { jsx as _jsx } from "preact/jsx-runtime";
import styles from './styles/ModalBackground.module.scss';
const ModalBackground = ({ onClick }) => {
    return _jsx("div", { class: styles.modalBackground, onClick: onClick }, void 0);
};
export default ModalBackground;
